import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { useAuth } from '@/lib/auth';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

const ACTION_LABELS = {
  create: 'إنشاء', update: 'تعديل', delete: 'حذف',
  import: 'استيراد', timeline_add: 'إجراء تحصيل', timeline_delete: 'حذف إجراء',
  assign: 'إسناد', timeline: 'إضافة إجراء', refer_to_legal: 'إحالة قانونية',
  payment_add: 'إضافة دفعة', payment_delete: 'حذف دفعة',
  bulk_update: 'تحديث دفعة', bulk_timeline: 'إجراء جماعي', email: 'إرسال بريد',
};

export default function AuditLog() {
  const { currentDepartment } = useAuth();
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const params = currentDepartment ? { department: currentDepartment } : {};
    api.get('/audit-log', { params }).then(({ data }) => setLogs(data)).finally(() => setLoading(false));
  }, [currentDepartment]);

  const isLegal = currentDepartment === 'legal';
  const accent = isLegal ? '#1E3A5F' : '#B4935A';
  const scopeLabel = isLegal ? 'الإدارة القانونية والقضائية' : 'إدارة التحصيل';

  return (
    <div className="space-y-5" data-testid="audit-page">
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <div className="text-xs uppercase tracking-widest mb-1" style={{ color: accent }}>Audit Trail</div>
          <h1 className="text-3xl font-bold text-slate-900">سجل العمليات</h1>
          <p className="text-sm text-slate-500 mt-1">
            سجل مستقل لعمليات <span className="font-semibold" style={{ color: accent }}>{scopeLabel}</span>
          </p>
        </div>
        <Badge variant="outline" className="border-slate-300" data-testid="audit-scope-badge">
          نطاق العرض: {scopeLabel}
        </Badge>
      </div>

      <Card className="border border-slate-200 rounded-md shadow-none overflow-hidden">
        <table className="w-full text-sm data-table">
          <thead className="bg-slate-50">
            <tr>
              <th className="text-start p-3 text-xs uppercase tracking-wider text-slate-600 font-medium">التوقيت</th>
              <th className="text-start p-3 text-xs uppercase tracking-wider text-slate-600 font-medium">المستخدم</th>
              <th className="text-start p-3 text-xs uppercase tracking-wider text-slate-600 font-medium">العملية</th>
              <th className="text-start p-3 text-xs uppercase tracking-wider text-slate-600 font-medium">الكيان</th>
              <th className="text-start p-3 text-xs uppercase tracking-wider text-slate-600 font-medium">المعرف</th>
              <th className="text-start p-3 text-xs uppercase tracking-wider text-slate-600 font-medium">IP</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={6} className="p-6 text-center text-slate-500">جاري التحميل...</td></tr>
            ) : logs.length === 0 ? (
              <tr><td colSpan={6} className="p-8 text-center text-slate-500">لا يوجد سجل ضمن هذا النطاق</td></tr>
            ) : logs.map(l => (
              <tr key={l.id} className="border-t border-slate-100" data-testid={`audit-row-${l.id}`}>
                <td className="p-3 mono text-xs text-slate-600">{new Date(l.timestamp).toLocaleString('ar-SA')}</td>
                <td className="p-3">{l.user_name || l.user_email}</td>
                <td className="p-3"><Badge variant="outline" className="border-slate-300">{ACTION_LABELS[l.action] || l.action}</Badge></td>
                <td className="p-3 text-slate-600">{l.entity}</td>
                <td className="p-3 mono text-xs text-slate-500">{l.entity_id?.slice(0, 8)}</td>
                <td className="p-3 mono text-xs text-slate-500">{l.ip || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
